import dayjs from "dayjs";

export function moment(value, format) {
	return dayjs.unix(value).format(format);
}

export const hideText = value => {
	if (!value) return value;
	return `${value.substr(0, 5)}*******************${value.substr(value.length - 5, 5)}`;
};

export function toFixed(num, digit = 2) {
	return Number(num).toFixed(digit);
}

export function toFloor(num, digit = 2) {
	return (Math.floor(Number(num) * 10000) / 10000).toFixed(digit);
}

export function toCeil(num, digit = 2) {
	return (Math.ceil(Number(num) * 10000) / 10000).toFixed(digit);
}

var addWan = function(integer, number, mutiple, decimalDigit) {
	var digit = getDigit(integer);
	if (digit > 3) {
		var remainder = digit % 8;
		if (remainder >= 5) {
			// ‘十万’、‘百万’、‘千万’显示为‘万’
			remainder = 4;
		}
		return Math.round(number / Math.pow(10, remainder + mutiple - decimalDigit)) / Math.pow(10, decimalDigit) + "万";
	} else {
		return Math.round(number / Math.pow(10, mutiple - decimalDigit)) / Math.pow(10, decimalDigit);
	}
};

var getDigit = function(integer) {
	var digit = -1;
	while (integer >= 1) {
		digit++;
		integer = integer / 10;
	}
	return digit;
};

export function toChineseNum(number, decimalDigit = 2) {
	let isAbs = number >= 0;
	let abs = Math.abs(number);

	var integer = Math.floor(abs);
	var digit = getDigit(integer);
	// ['个', '十', '百', '千', '万', '十万', '百万', '千万'];
	var unit = [];
	if (digit > 3) {
		var multiple = Math.floor(digit / 8);
		if (multiple >= 1) {
			var tmp = Math.round(integer / Math.pow(10, 8 * multiple));
			unit.push(addWan(tmp, number, 8 * multiple, decimalDigit));
			for (var i = 0; i < multiple; i++) {
				unit.push("亿");
			}
			return (isAbs ? "" : "-") + unit.join("");
		} else {
			return (isAbs ? "" : "-") + addWan(integer, abs, 0, decimalDigit);
		}
	} else {
		return number;
	}
}
